import apiClient from './api.service';

/**
 * Push Token Service
 * Handles FCM push token registration and management
 */

export interface PushTokenData {
  token: string;
  deviceType?: 'ios' | 'android' | 'web';
  deviceId?: string;
  appVersion?: string;
}

class PushTokenService {
  /**
   * Register or update a push token
   */
  async registerToken(data: PushTokenData) {
    console.log('[PUSH TOKEN SERVICE] Registering token:', {
      tokenPreview: data.token.substring(0, 30) + '...',
      deviceType: data.deviceType,
      deviceId: data.deviceId?.substring(0, 30) + '...'
    });
    const response = await apiClient.post('/push-tokens', data);
    console.log('[PUSH TOKEN SERVICE] ✅ Token registered:', response.data);
    return response.data;
  }

  /**
   * Get user's active tokens
   */
  async getTokens() {
    const response = await apiClient.get('/push-tokens');
    return response.data.data.tokens;
  }

  /**
   * Remove a specific token
   */
  async removeToken(token: string) {
    const response = await apiClient.delete(`/push-tokens/${encodeURIComponent(token)}`);
    return response.data;
  }

  /**
   * Deactivate a specific token (e.g., on logout from current device)
   */
  async deactivateToken(token: string) {
    try {
      const response = await apiClient.post('/push-tokens/deactivate', { token });
      return response.data;
    } catch (error) {
      console.error('[PUSH TOKEN SERVICE] Error deactivating token:', error);
      throw error;
    }
  }

  /**
   * Deactivate all user tokens (e.g., on logout from all devices)
   */
  async deactivateAllTokens() {
    const response = await apiClient.post('/push-tokens/deactivate-all');
    return response.data;
  }
}

export default new PushTokenService();

